import { useCurrentUser } from '@bonusly/who-am-i';

/**
 * Centralizes the "can this user give points? / an amount?" rules that drive the points
 * chips and amount affordances (amount button/module + amount chip) across the
 * give box, comment composer, and related surfaces.
 *
 * Keeping this in one place avoids the rules drifting apart.
 */
export const useGivePointsCapabilities = () => {
	const user = useCurrentUser();

	// Whether the user is allowed to give points at all (product tier and user mode checks on the backend)
	const canGivePoints = user.can_give_non_zero;
	// Whether the company gives users a monthly allowance
	const hasMonthlyAllowance = user.monthly_allowance > 0;

	const canGiveAmount = canGivePoints && hasMonthlyAllowance;

	return { canGivePoints, canGiveAmount };
};
